window.addEventListener('load', (event) => {
  document.querySelector('nav.mega-hidden').classList.remove('mega-hidden');
});


window.addEventListener('load', function () {
  const backToTopBtn = document.getElementById("backtopbutton");

  if (!backToTopBtn) return;

  // Show/hide button on scroll
  window.addEventListener("scroll", function () {
    if (window.scrollY > 300) {
      backToTopBtn.classList.add("show");
    } else {
      backToTopBtn.classList.remove("show");
    }
  });

  // Smooth scroll to top
  backToTopBtn.addEventListener("click", function (e) {
    e.preventDefault();
    window.scrollTo({
      top: 0,
      behavior: "smooth"
    });
  });
});